import React from 'react';
import { SectionTitle } from './SectionTitle';
import { turnSection } from '../data/salesCopy';
export function TurnSection() {
  return <section className="bg-brand-ivoryLight px-4 py-7 sm:py-9" data-id="element-280" data-mp="3ghaxdtmym37q">
      <div className="mx-auto max-w-3xl" data-id="element-281" data-mp="3u7eey7aw98qu">
        <SectionTitle data-id="element-282" data-mp="3u8fvgraoinfy">⏱️ {turnSection.heading}</SectionTitle>

        <p className="mt-4 text-center text-[13px] font-medium leading-snug text-brand-charcoal/85 sm:text-[15px]" data-id="element-283" data-mp="3pfd8x34bke99">
          {turnSection.intro}
        </p>

        <ul className="mt-4 grid gap-1.5 sm:grid-cols-2" data-id="element-284" data-mp="30tux7j9b13b">
          {turnSection.pairs.map(pair => <li key={pair.need} className="flex items-baseline justify-between gap-2 rounded border border-brand-sand/60 bg-white px-3 py-2 shadow-sm" data-id="element-285" data-mp="h0mkgzj1rb9p">
              <span className="text-[12.5px] font-semibold leading-snug text-brand-charcoal/90 sm:text-[13.5px]" data-id="element-286" data-mp="2irzl3cdzewzy">
                {pair.need}
              </span>
              <span className="shrink-0 text-[11px] font-extrabold uppercase tracking-wide text-brand-sage" data-id="element-287" data-mp="2dufwbijnr1tr">
                {pair.answer}
              </span>
            </li>)}
        </ul>

        <div className="mt-4 space-y-1 text-center text-[13px] font-semibold leading-snug text-brand-charcoal sm:text-[15px]" data-id="element-288" data-mp="2u983px4y7rpm">
          {turnSection.close.map(line => <p key={line} data-id="element-289" data-mp="33zktc3rmeb2m">{line}</p>)}
        </div>
      </div>
    </section>;
}